import React from "react";
import AdminDrawer from "./AdminDrawer";
import EmployeeRecordPanel, { EmployeeRecordActions } from "./EmployeeRecordPanel";

/** "Employee Record" side drawer opened from the joinee list. "View All Forms" goes to the review page. */
function JoineeViewDrawer(props) {
  return (
    <AdminDrawer
      open={props.open}
      onClose={props.onClose}
      loading={props.loading}
      title="Employee Record"
      subtitle="Form submissions, logs and verification checklist"
      footer={
        <EmployeeRecordActions
          onDownload={props.onDownload}
          downloading={props.downloading}
          onViewAll={props.onOpen}
          disabled={props.loading}
        />
      }
    >
      <EmployeeRecordPanel
        details={props.details}
        isActive={props.isActive}
        onToggleActive={props.onToggleActive}
      />
    </AdminDrawer>
  );
}

export default JoineeViewDrawer;
